import RestApiModel from '@/services/Api/RestApiModel';

class MachineApplications extends RestApiModel {
  static getResourceEndpoint() {
    return '/machine-apps';
  }

  /**
   * Create IP Whitelist against the app
   * @param applicationId
   * @param ip
   * @returns {Promise<AxiosResponse<T>>}
   */
  static createWhitelistIp(applicationId, ip) {
    return api.post(`${this.getResourceIdEndpoint(applicationId)}/ip`, { ip });
  }

  /**
   *
   * @param applicationId
   * @param ip
   * @returns {Promise<AxiosResponse<T>>}
   */
  static async deleteWhitelistIp(applicationId, ipId) {
    return api.delete(`${this.getResourceIdEndpoint(applicationId)}/ip/${ipId}`);
  }

  /**
   *
   * @param applicationId
   * @param ip
   * @returns {Promise<AxiosResponse<T>>}
   */
  static async updateWhitelistIp(applicationId, { applicationIpId, ip}) {
    return api.put(`${this.getResourceIdEndpoint(applicationId)}/ip/${applicationIpId}`, { ip });
  }
}

export default MachineApplications;
